module.exports = "<inscricao-aluno-list\t[tipo] = \"1\">  </inscricao-aluno-list>\n"